var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrincess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 120H0V0H120V120ZM2.07111 117.931H118.053V2.06897H2.07111V117.931Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22094 119.462L0.599609 118.862L34.6072 35.1724L34.8143 34.9655L118.756 0.599945L119.398 1.22063L85.1837 84.4965L84.9765 84.6827L1.22094 119.462ZM35.4356 35.5862L1.84227 117.931L84.3759 83.8758L118.052 2.06891L35.4356 35.5862Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.756 119.462L35.4356 85.3034L35.2285 85.0965L0.599609 1.22063L1.22094 0.599945L85.805 34.9861L85.9914 35.193L119.398 118.572L118.756 119.462ZM36.0363 84.4965L118.052 117.931L85.1837 35.793L1.84227 2.06891L36.0363 84.4965Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8303 35.193H34.8154V15.124L35.4368 14.524H85.1848V15.5378H35.8303V35.193Z",
    fill: "#888888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5971 14.5241H84.5823V35.193H85.5971V14.5241Z",
    fill: "#888888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.047 34.7794H85.1851V35.7932H105.047V34.7794Z",
    fill: "#888888"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 34.5723H104.632V84.6826H105.646V34.5723Z",
    fill: "#888888"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.253 84.0829H83.9624V85.0967H105.253V84.0829Z",
    fill: "#888888"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1846 105.559H34.6082V104.545H84.584V83.4621H85.5988V104.959L85.1846 105.559Z",
    fill: "#888888"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8303 83.8761H34.8154V104.752H35.8303V83.8761Z",
    fill: "#888888"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6459 84.083H14.9556V85.0968H35.6459V84.083Z",
    fill: "#888888"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7619 83.6689H14.7471V35.1931L15.3477 34.7793H35.0232V35.7931H15.7619V83.6689Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincess);
export default __webpack_public_path__ + "static/media/Princess.bd535043d16509d850c168357e505f07.svg";
export { ForwardRef as ReactComponent };